<div aria-hidden="true" class="ag-column-drop-title-bar ag-column-drop-vertical-title-bar">
    <span class="k-icon k-i-k-icon k-i-text-wrap" unselectable="on" role="presentation" style="font-weight: 500; font-size: var(--tt-font-size-lg)"></span
    ><span class="ag-column-drop-title ag-column-drop-vertical-title" ttTranslateWord="text_wrapping"></span>
</div>
<div style="height: var(--tt-height); display: flex">
    <div role="presentation" class="ag-pivot-mode-select ag-labeled ag-label-align-right ag-toggle-button ag-input-field">
        <div class="ag-input-field-label ag-label ag-toggle-button-label" aria-hidden="false" ttTranslateWord="column_headers"></div>
        <div class="ag-wrapper ag-input-wrapper ag-toggle-button-input-wrapper" [ngClass]="{ 'ag-checked': headerTextWrapping }" role="presentation">
            <input
                ref="eInput"
                class="ag-input-field-input ag-toggle-button-input"
                aria-labelledby="ag-39-label"
                type="checkbox"
                id="ag-39-input"
                tabindex="0"
                [(ngModel)]="headerTextWrapping"
                (ngModelChange)="toggleHeaderTextWrapping()"
            />
        </div>
    </div>
</div>

<div style="height: var(--tt-height); display: flex">
    <div role="presentation" class="ag-pivot-mode-select ag-labeled ag-label-align-right ag-toggle-button ag-input-field">
        <div class="ag-input-field-label ag-label ag-toggle-button-label" aria-hidden="false" ttTranslateWord="rows"></div>
        <div class="ag-wrapper ag-input-wrapper ag-toggle-button-input-wrapper" [ngClass]="{ 'ag-checked': rowTextWrapping }" role="presentation">
            <input
                ref="eInput"
                class="ag-input-field-input ag-toggle-button-input"
                aria-labelledby="ag-39-label"
                type="checkbox"
                id="ag-39-input"
                tabindex="0"
                [(ngModel)]="rowTextWrapping"
                (ngModelChange)="toggleRowTextWrapping()"
            />
        </div>
    </div>
</div>
<div class="ag-filter-separator"></div>
